<template>
	<div class="row">
		<div class="col-6">
			<highcharts :options="selectOptions1"></highcharts>
		</div>
		<div class="col-6">
			<highcharts :options="selectOptions2"></highcharts>
		</div>
	</div>
</template>

<script>

import DashboardMonthlyPieChart from "@/views/components/charts/GroupDashboard.vue";
import DashboardMonthlyBarChart from "@/views/components/charts/RemainingVue.vue";
import {Chart} from 'highcharts-vue'

export default {
	name: "pieChart",
	components: {
		highcharts: Chart,
		DashboardMonthlyBarChart,
		DashboardMonthlyPieChart,
	},
	data() {
		return {}
	},
	computed: {
		// monthly
		montlys() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.monthly) {
					let obj = {}
					obj.name = this.monthly[listKey].departmentName
					obj.y = this.monthly[listKey].value
					obj.drilldown = this.monthly[listKey].departmentName
					obj.code = this.monthly[listKey].code
					list.push(obj)
					obj = {}
				}
				return list
			}


		},
		selectOptions1() {
			return {
				chart: {
					type: 'line',
					// zoomType: 'x'
				},
				title: {
					align: 'center',
					text: '<b style="color:#00a576 ">Доход (Месячный)</b>',
				},
				subtitle: {
					align: 'left',
					// text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
				},
				accessibility: {
					announceNewData: {
						enabled: true
					}
				},
				xAxis: {
					type: 'category',
					labels: {
						skew3d: true,
						style: {
							fontSize: '16px'
						}
					}
				},
				yAxis: {
					title: {
						text: '<b style="color:#00a576 ">Доход (Месячный)</b>',
						margin: 20,
					}

				},
				legend: {
					enabled: false
				},
				plotOptions: {
					series: {
						borderWidth: 0,
						dataLabels: {
							enabled: true,
							format: '{point.y}<span style="color:{point.color}">{point.code}</span>'
						}
					}
				},

				tooltip: {
					headerFormat: '<span style="font-size:11px;color:{point.color}">{series.name}</span><br>',
					pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}{point.code}</b><br/>'
				},

				series: [
					{
						name: '<b style="color:#00a576 ">Доход (Месячный)</b>',
						colorByPoint: true,
						data: this.montlys
					}
				],
			}
		},

		//daily
		dailys() {
			let list = [];
			if (list.length === 0) {
				for (const listKey in this.daily) {
					let obj = {}
					obj.name = this.daily[listKey].departmentName
					obj.y = this.daily[listKey].value
					obj.drilldown = this.daily[listKey].departmentName
					obj.code = this.daily[listKey].code
					list.push(obj)
					obj = {}
				}
				return list
			}


		},
		daily2() {
			let list = [];
			if (list.length === 0) {
				for (const listKey in this.daily) {
					list.push(this.daily[listKey].value)
				}
				return list
			}
		},
		daily3() {
			let list = [];
			if (list.length === 0) {
				for (const listKey in this.daily) {
					list.push(this.daily[listKey].departmentName)
				}
				return list
			}
		},
		selectOptions2() {
			return {
				chart: {
					type: 'column',
					options3d: {
						enabled: true,
						alpha: 10,
						beta: 25,
						depth: 70
					}
				},
				title: {
					align: 'center',
					text: '<b style="color:#125ebb ">Доход (Вчерашний)</b>',
					// color:'#00a576'
				},
				subtitle: {
					align: 'left',
					// text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
				},
				accessibility: {
					announceNewData: {
						enabled: true
					}
				},
				xAxis: {
					type: 'category'
				},
				yAxis: {
					title: {
						text: '<b style="color:#125ebb ">Доход (Вчерашний)</b>'
					}

				},
				legend: {
					enabled: false
				},
				plotOptions: {
					series: {
						borderWidth: 0,
						dataLabels: {
							enabled: true,
							format: `{point.y:.1f} <span style="color:{point.color}">{point.code}</span>`
						},
					},
					column: {
						depth: 25
					}
				},
				tooltip: {
					headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
					pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}{point.code}</b><br/>'
				},

				series: [
					{
						name: '<b style="color:#125ebb ">Доход (Вчерашний)</b>',
						colorByPoint: true,
						data: this.dailys
					}
				],
			}
		}
	},
	props: ['monthly', 'daily', 'remaining', 'saleSum'],
	async created() {

	}
}
</script>
<style scoped>
#pieChart {
	width: 100%;
	height: 600px;
}
</style>
